export const quizQuestions = [
  {
    question: "What is your current educational status?",
    type: "single",
    options: [
      "Completed Class 10",
      "Completing Class 10 this year",
      "Completed Class 12",
      "Completing Class 12 this year",
      "Pursuing graduation",
      "Other",
    ],
  },
  {
    question: "Which subjects do you enjoy or perform well in? (Select up to 3)",
    type: "multi",
    max: 3,
    options: [
      "Mathematics",
      "Physics",
      "Chemistry",
      "Biology",
      "Computer Science / IT",
      "History / Civics",
      "Geography",
      "Economics / Business Studies / Accountancy",
      "Languages & Literature",
      "Fine / Performing Arts",
      "Physical Education / Sports",
      "Other",
    ],
    helper: "Choose up to 3 options",
  },
  {
    question: "Which degree do you plan to pursue after Class 12?",
    type: "single",
    options: [
      "Engineering (BTech/BE)",
      "Medical (MBBS/BDS/Paramedical)",
      "Science (BSc/BCA etc.)",
      "Commerce (BCom/CA/CS/CFA etc.)",
      "Management (BBA/BMS etc.)",
      "Law (LLB/Integrated Law)",
      "Design/Fine Arts",
      "Humanities (BA/BSW etc.)",
      "Skilled Trades / Vocational",
      "Not sure yet",
      "Other",
    ],
    helper: "Select the closest option. Choose “Other” if not listed.",
  },
  {
    question: "Which career fields interest you the most? (Select all that apply)",
    type: "multi",
    max: 99,
    options: [
      "Engineering & Technology",
      "Medical & Healthcare",
      "Science & Research",
      "Business & Management",
      "Commerce, Banking & Finance",
      "Civil Services & Government",
      "Law & Legal Services",
      "Education & Teaching",
      "Creative Arts, Media & Design",
      "Social Work & Community",
      "Defense & Armed Forces",
      "Skilled Trades & Vocational",
      "Not sure yet",
      "Other",
    ],
  },
  {
    question: "What entrance exams are you planning to prepare for? (Select all that apply)",
    type: "multi",
    max: 99,
    options: [
      "JEE Main/Advanced",
      "NEET",
      "CUET",
      "State engineering entrance",
      "State medical entrance",
      "CLAT (Law)",
      "Design (NIFT/NID/UCEED)",
      "Management (CAT/XAT/MAT)",
      "UPSC / State PSC",
      "Banking / SSC / Railways",
      "None at present",
      "Other",
    ],
  },
  {
    question: "What factors matter most when choosing a college/course? (Select top 2)",
    type: "multi",
    max: 2,
    options: [
      "Job placements",
      "College reputation / ranking",
      "Affordable fees / scholarships",
      "Location near home",
      "Curriculum & specializations",
      "Faculty quality",
      "Facilities / labs / hostels",
      "Internships & practical exposure",
      "Other",
    ],
    helper: "Pick up to 2 options",
  },
  {
    question: "What is your family's monthly income range?",
    type: "single",
    options: [
      "Below ₹25,000",
      "₹25,000 - ₹50,000",
      "₹50,000 - ₹1,00,000",
      "Above ₹1,00,000",
      "Prefer not to say",
    ],
  },
  {
    question: "What are your strongest skills? (Select up to 3)",
    type: "multi",
    max: 3,
    options: [
      "Problem-solving & analytical thinking",
      "Communication (verbal/written)",
      "Leadership & teamwork",
      "Creativity & innovation",
      "Technical / computer skills",
      "Research & analysis",
      "Practical / mechanical abilities",
      "People skills & empathy",
      "Other",
    ],
    helper: "Choose up to 3 options",
  },
  {
    question: "What constraints or challenges might affect your education? (Select all that apply)",
    type: "multi",
    max: 99,
    options: [
      "Financial limitations",
      "Limited colleges nearby",
      "Family responsibilities",
      "Health issues",
      "Language barriers",
      "No significant constraints",
      "Other",
    ],
  },
  {
    question: "What are your long-term career goals? (Optional)",
    type: "text",
    placeholder: "Your answer (optional)",
  },
];